export type OrderSource = 'mobile' | 'partner' | 'admin';

export const ORDER_SOURCE_OPTIONS: { value: OrderSource; label: string }[] = [
  { value: 'mobile', label: 'Mobile App' },
  { value: 'partner', label: 'Partner' },
  { value: 'admin', label: 'Admin' },
];

export function formatOrderSourceLabel(
  source?: string | null
): string {
  const match = ORDER_SOURCE_OPTIONS.find((item) => item.value === source);
  return match?.label || '-';
}
